/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * Import Context
 */

import { ContentContext } from "context/contentContext";

/**
 * import components
 */

/**
 * styled components
 */

const Wrapper = styled.div`
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 1px;
    top: 0;
    right: 41px;
    bottom: 0;
    background-color: ${t.color.greyAlto};
  }
  ${t.mixins.sm(`
    &::before {
      right: 32px;
    }
  `)}
`;
const List = styled.select`
  height: 36px;
  padding: 0 82px 0 17px;
  ${t.mixins.rem(13, 36)}
  font-family: ${t.font.primary};
  color: ${t.color.gray};
  border-radius: 3px;
  border: 1px solid ${t.color.greyAlto};
  background: linear-gradient(180deg, ${t.color.greyZircon}, ${t.color.greyGallery});

  ${t.mixins.sm(`
    height: 29px;
    padding: 0 65px 0 14px;
    ${t.mixins.rem(11, 29)}
  `)}
`;
const Dropdown = styled.img.attrs({ src: t.image.dropdown })`
  position: absolute;
  width: 11px;
  height: 5px;
  top: 16px;
  right: 16px;
  pointer-events: none;

  ${t.mixins.sm(`
    top: 13px;
    right: 12px;
  `)}
`;
const Option = styled.option``;

/**
 * list component is..
 */

const Form__list = ({ style, answers, updateValue, filled = undefined }) => {
  const { c } = useContext(ContentContext);
  const defaultOption = c("home.form.defaultOption");
  return (
    <Wrapper>
      <List
        style={style}
        onChange={e => {
          if (e.target.value !== defaultOption) {
            updateValue(e.target.value);
          }
        }}
      >
        <Option>{defaultOption}</Option>
        {answers.map(answer => {
          const { id, title } = answer;
          return (
            <Option key={id} value={id} selected={id === filled}>
              {title}
            </Option>
          );
        })}
      </List>
      <Dropdown />
    </Wrapper>
  );
};

export default Form__list;

Form__list.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Form__list.defaultProps = {
  style: {},
};
